// export const API_BASE_URL =
//   "https://kvlapi.octaloptimum.in/api/v1/";

// export const API_BASE_URL =
//   "http://localhost:5300/api/v1/";

export const API_BASE_URL =
  "https://api.kvlmatrimony.com/api/v1/";

export const API_PATHS = {

  adminlogin: "admin/login",

  getUser: "admin/get-user",
  getunverifiedUser: "admin/get-unverified-user",

  approveDocument: "admin/approve-user-doc",
  assignPlan: "admin/assign-plan",


  // plan ==== >
  addPlan: "admin/add-plan",
  getPlan: "admin/get-plan",
  editPlan: "admin/edit-plan",
  deletePlan: "admin/delete-plan",
  getPayment: "admin/get-payment",
  getActivity: "admin/get-activity",
  getSubscription: "admin/get-subscription",

  getuserSubscription: "admin/get-user-subscription",

  getDashSummary: "admin/get-dash-summary",
  getDashSubscription: "admin/get-dash-subscription",
  getDashRegistartion: "admin/get-dash-registration",
  getDashData: "admin/get-dash-data"




};
